import { NavigationEnd, RouteConfigLoadEnd, RouteConfigLoadStart, Router, RouterModule } from '@angular/router';
import { AppComponent } from './app.component';
import { AppRouteGuard } from './shared/common/auth/auth-route-guard';
import { NotificationsComponent } from './shared/layout/notifications/notifications.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { NgModule } from '@angular/core';



//#region External Module Imports
import { OnlineHelperModule } from '@axilla/axilla-online-helper';

@NgModule({
    imports: [OnlineHelperModule]
})
export class ExternalHelperModule {
}
//#endregion External Module Imports


@NgModule({
    imports: [
        RouterModule.forChild([
            {
                path: 'app',
                component: AppComponent,
                canActivate: [AppRouteGuard],
                canActivateChild: [AppRouteGuard],
                children: [
                    {
                        path: '',
                        children: [
                            { path: 'notifications', component: NotificationsComponent }
                        ]
                    },
                    {
                        path: 'admin',
                        loadChildren: () => import('@app/admin/admin.module').then(m => m.AdminModule), //Lazy load admin module
                        data: { preload: true },
                        canLoad: [AppRouteGuard]
                    },
                    {
                        path: 'webshop',
                        loadChildren: () => import('@app/webshop/webshop.module').then(f => f.WebshopModule),
                        data: { preload: true }
                    },
                    {
                        path: 'ihsc',
                        loadChildren: () => import('@app/ihsc/ihsc.module').then(f => f.IHSCModule),
                        data: { preload: true }
                    },
                    {
                        path: 'helper',
                        loadChildren: () => import('@app/app-routing.module').then(m => m.ExternalHelperModule), //Lazy load admin module
                        data: { preload: true },
                        canLoad: [AppRouteGuard]
                    }
                ]
            }
        ])
    ],
    exports: [RouterModule]
})

export class AppRoutingModule {
    constructor(
        private router: Router,
        private spinnerService: NgxSpinnerService
    ) {
        router.events.subscribe((event) => {

            if (event instanceof RouteConfigLoadStart) {
                spinnerService.show();
            }

            if (event instanceof RouteConfigLoadEnd) {
                spinnerService.hide();
            }

            if (event instanceof NavigationEnd) {
                document.querySelector('meta[property=og\\:url').setAttribute('content', window.location.href);
            }
        });
    }
}
